module.exports = __webpack_public_path__ + "static/media/findingAHome2007.990bd9c8.jpg";